import { isBefore, addMinutes, isAfter } from 'date-fns'

const storageName = 'CONTRATS_A_VALIDER'
const shopContratDuration = (isAgrial) => isAgrial ? window.PROPERTIES.get('SHOP_CONTRAT_DURATION_CONSEILLER') : window.PROPERTIES.get('SHOP_CONTRAT_DURATION')

const saveRecapContratsInStorage = (numtiers, recapContrats) => {
  const storage = {
    updateTime: Date.now(),
    content: recapContrats
  }
  localStorage.setItem(`${storageName}_${numtiers}`, JSON.stringify(storage))
}

const getRecapContratsFromStorage = (numtiers, isAgrial = false) => {
  let results = []
  const storage = JSON.parse(localStorage.getItem(`${storageName}_${numtiers}`))
  // Si la durée de stockage est dépassée, on supprime la donnée du localStorage
  if (storage) {
    if (shopContratDuration(isAgrial) > 0 && isBefore(addMinutes(storage.updateTime, shopContratDuration(isAgrial)), Date.now())) {
      localStorage.removeItem(`${storageName}_${numtiers}`)
    } else {
      results = storage.content.length >= 0 ? storage.content : []
    }
  }
  return results
}

const getRecapContratsUpdateTimeInStorage = (numtiers) => {
  return JSON.parse(localStorage.getItem(`${storageName}_${numtiers}`))?.updateTime
}

const getDefaultState = () => {
  return {
    recapContrats: [],
    createContratReport: null
  }
}
const module = {
  namespaced: true,
  state: getDefaultState(),

  getters: {
    recapContrats (state) {
      return state.recapContrats
    },
    recapContratsValides (state) {
      return state.recapContrats.filter(c => c.valid)
    },
  },

  mutations: {
    SET_RECAP_CONTRATS (state, { recapContrats }) {
      state.recapContrats = recapContrats || []
    },
    REFRESH_DELAIS_EXPIRATION (state, { numtiers, isAgrial }) {
      const delaiSouscriptionContrat = getRecapContratsUpdateTimeInStorage(numtiers)
      if (delaiSouscriptionContrat) {
        if (shopContratDuration(isAgrial) && isAfter(addMinutes(delaiSouscriptionContrat, shopContratDuration(isAgrial)), Date.now())) {
          state.delaiAvantExpiration = addMinutes(delaiSouscriptionContrat, shopContratDuration(isAgrial)) - Date.now()
        }
      }
    },
    RESET (state, numtiers) {
      Object.assign(state, getDefaultState())
      saveRecapContratsInStorage(numtiers, [])
    }
  },

  actions: {
    fetchRecapContrats ({ commit, rootGetters }) {
      const numtiers = rootGetters['adherent/numtiers']
      const isAgrial = rootGetters['user/isUtilisateurAgrial']
      const recapContratsFromstorage = getRecapContratsFromStorage(numtiers, isAgrial)
      commit('SET_RECAP_CONTRATS', { recapContrats: recapContratsFromstorage, numtiers })
      commit('REFRESH_DELAIS_EXPIRATION', { numtiers, isAgrial })
      return recapContratsFromstorage
    },
    reset ({ commit, rootGetters }) {
      let numtiers = rootGetters['adherent/numtiers']
      commit('RESET', numtiers)
    }
  }
}

export default module
